// Evaluation rounds
export const GET_COMPANY_EVALUATIONS_REQUEST =
  "GET_COMPANY_EVALUATIONS_REQUEST";
export const GET_COMPANY_EVALUATIONS_RESPONSE =
  "GET_COMPANY_EVALUATIONS_RESPONSE";
export const CREATE_COMPANY_EVALUATION_REQUEST =
  "CREATE_COMPANY_EVALUATION_REQUEST";
export const UPDATE_COMPANY_EVALUATION_REQUEST =
  "UPDATE_COMPANY_EVALUATION_REQUEST";

// Evaluation forms
export const GET_COMPANY_EVALUATION_FORMS_REQUEST =
  "GET_COMPANY_EVALUATION_FORMS_REQUEST";
export const GET_COMPANY_EVALUATION_FORMS_RESPONSE =
  "GET_COMPANY_EVALUATION_FORMS_RESPONSE";
export const GET_COMPANY_EVALUATION_FORM_REQUEST =
  "GET_COMPANY_EVALUATION_FORM_REQUEST";
export const GET_COMPANY_EVALUATION_FORM_RESPONSE =
  "GET_COMPANY_EVALUATION_FORM_RESPONSE";
export const SUBMIT_COMPANY_EVALUATION_FORM_REQUEST =
  "SUBMIT_COMPANY_EVALUATION_FORM_REQUEST";
export const SUBMIT_COMPANY_EVALUATION_FORM_RESPONSE =
  "SUBMIT_COMPANY_EVALUATION_FORM_RESPONSE";
